var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"culture"},[_c('div',{staticClass:"banner"}),_c('div',{staticClass:"culturecontent"},[_c('div',{staticClass:"navs"},[_c('navlist',{attrs:{"navlist":_vm.navlist,"navindex":_vm.navindex},on:{"returnpath":_vm.returnpath}})],1),_c('div',{staticClass:"miancontent"},[(_vm.navindex > -1)?_c('productbuild',{attrs:{"datalist":_vm.navlist.list[_vm.navindex].children &&
          _vm.navlist.list[_vm.navindex].children.length > 0
            ? _vm.navlist.list[_vm.navindex].children
            : _vm.navlist.list[_vm.navindex].content,"type":_vm.navlist.list[_vm.navindex].children &&
          _vm.navlist.list[_vm.navindex].children.length > 0
            ? 1
            : 0,"navindex":_vm.navindex,"tablelist":_vm.tablelist},on:{"changelast":_vm.changelast}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }